import React,{useEffect, useRef, useState} from 'react';
import { NavLink } from 'react-router-dom';
import './app.header.scss'
const AppHeader = React.forwardRef((props, ref) => {
    const [panelToogle, setPanel] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const inputRef = useRef(null);
    function toggleButton () {
        if(!panelToogle) setPanel(true);
        else setPanel(false);
    }
   
    function toggleButtonOff () {
        setPanel(false);
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }


    useEffect(() => {
        window.addEventListener('scroll', handleScroll, true);
    },[]);
    
    
      const handleScroll = () => {
        const lastScrollY = window.scrollY;
        lastScrollY>100 ? inputRef.current.className = "sticky" : inputRef.current.className = "";
      };
      const phoneClickHandler = () => {
        if(!isActive) setIsActive(true);
        else setIsActive(false);
      };
    return(
        <header id="app-header" ref={inputRef}>
            <nav className="navbar navbar-default">
                <div className={"container " + (panelToogle ? 'openNav' : '')}>
                <div class="navbar-brand" href="//www.airtel.in">
                    <span class="logo"><img src="./logo_c.svg" /></span>
                    <div class="logo-text">
                    <span class="">Compact</span><span>IT Solutions</span>
                    </div>
                </div>
                    <a className="mobile-nav icon-menu" onClick={toggleButton}></a>
                    <ul id="main-menu" className="main-menu">
                        <li><NavLink exact to="/" activeClassName="active" onClick={e => toggleButtonOff(false)}>Home</NavLink></li>
                        <li><NavLink to="/about" activeClassName="active" onClick={e => toggleButtonOff(false)}>ABOUT US</NavLink></li>
                        <li><NavLink to="/services" activeClassName="active" onClick={e => toggleButtonOff(false)}>SERVICES</NavLink></li>
                        <li><NavLink to="/projects" activeClassName="active" onClick={e => toggleButtonOff(false)}>PROJECTS</NavLink></li>
                        <li><NavLink to="/contact" activeClassName="active" onClick={e => toggleButtonOff(false)}>CONTACT US</NavLink></li>
                    </ul>
                    <ul className="right-menu">
                        <li className={`phone ${isActive ? "active" :''}`}><img src="./whatsapp.png" width="20" height="20" alt="whatsapp" onClick={phoneClickHandler}/><span className="icon-phone"><a href="https://wa.me/+919891330157?text=I'm interested in your IT services for Laptop Repair">+91 9891330157</a></span></li>
                    </ul>   
                </div>
            </nav>
        </header>
    )
})

export default AppHeader;

